<template>
  <v-card-text class="ml-0 pl-0 pr-0">
    <v-timeline
      dense
      align-top
      class="ml-n8"
    >
      <v-timeline-item
        v-for="(log, idx) in logs"
        :key="idx"
        :class="log.type"
        small
      >
        <v-row class="ml-n6 pl-6 mt-n2 pt-2 hoverable-body">
          <v-col
            class="pl-0 pt-0"
            cols="10"
          >
            <div class="upper"><strong>{{ get(log, 'state.name', '') }}</strong></div>
            <div><strong>{{ getWho(log.creator) }}</strong></div>
            <div>{{ get(log, 'state.explanation', '') }}</div>
          </v-col>
          <v-col class="pt-0">
            <strong>{{ log.createdAt | date }}</strong> {{ log.createdAt | time }}
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</template>

<script>
import get from 'lodash/get'

export default {
  name: 'ApplicationEventsView',

  props: {
    logs: {
      type: Array,
      required: true
    }
  },

  methods: {
    get,

    getWho(item) {
      return item ? `${item.firstName} ${item.lastName}` : ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>